module.exports = __webpack_public_path__ + "static/media/24.b2838d7f.jpg";